// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"ChangePassword_buttonGroup__zDDsD"};